import { api } from "@/lib/orgApi";

export const V3_ROLECODE = "http://terminology.hl7.org/CodeSystem/v3-RoleCode";
export const PHYSICAL_TYPE_SYSTEM =
  "http://terminology.hl7.org/CodeSystem/location-physical-type";

export const LOCATION_TYPES = [
  { code: "OF", display: "Outpatient Facility" },
  { code: "HOSP", display: "Hospital" },
  { code: "PHARM", display: "Pharmacy" },
  { code: "RADDX", display: "Radiology / Diagnostics" },
  { code: "PC", display: "Primary Care Clinic" },
  { code: "OTH", display: "Other" },
];

export const PHYSICAL_TYPES = [
  { code: "bu", display: "Building" },
  { code: "si", display: "Site" },
  { code: "wi", display: "Wing" },
];

export const LOCATION_STATUSES = [
  { code: "active", display: "Active" },
  { code: "suspended", display: "Suspended" },
  { code: "inactive", display: "Inactive" },
];

export function fetchOrganizations() {
  return api.get("/organizations").then((r) => r.data.items || []);
}

export function resourceToForm(r) {
  const addr = r.address || {};
  const tele = (sys) => (r.telecom || []).find((t) => t.system === sys)?.value || "";
  return {
    name: r.name || "",
    status: r.status || "active",
    type: r.type?.[0]?.coding?.[0]?.code || "OF",
    physicalType: r.physicalType?.coding?.[0]?.code || "bu",
    managingOrgId: (r.managingOrganization?.reference || "").split("/")[1] || "",
    description: r.description || "",
    alias: (r.alias || []).join(", "),
    phone: tele("phone"),
    fax: tele("fax"),
    email: tele("email"),
    line1: addr.line?.[0] || "",
    line2: addr.line?.[1] || "",
    city: addr.city || "",
    state: addr.state || "",
    postalCode: addr.postalCode || "",
    country: addr.country || "US",
  };
}

export function formToPayload(f, orgs) {
  const org = (orgs || []).find((o) => o.id === f.managingOrgId);

  const telecom = [];
  if (f.phone?.trim()) telecom.push({ system: "phone", value: f.phone.trim(), use: "work" });
  if (f.fax?.trim()) telecom.push({ system: "fax", value: f.fax.trim(), use: "work" });
  if (f.email?.trim()) telecom.push({ system: "email", value: f.email.trim(), use: "work" });

  const line = [f.line1, f.line2].map((s) => s?.trim()).filter(Boolean);
  const hasAddr = line.length || f.city || f.state || f.postalCode;
  const address = hasAddr
    ? {
        use: "work",
        type: "physical",
        ...(line.length ? { line } : {}),
        ...(f.city?.trim() ? { city: f.city.trim() } : {}),
        ...(f.state?.trim() ? { state: f.state.trim() } : {}),
        ...(f.postalCode?.trim() ? { postalCode: f.postalCode.trim() } : {}),
        ...(f.country?.trim() ? { country: f.country.trim() } : {}),
      }
    : undefined;

  const typeDisplay = LOCATION_TYPES.find((t) => t.code === f.type)?.display;
  const type = f.type
    ? [{ coding: [{ system: V3_ROLECODE, code: f.type, display: typeDisplay }] }]
    : undefined;

  const ptDisplay = PHYSICAL_TYPES.find((t) => t.code === f.physicalType)?.display;
  const physicalType = f.physicalType
    ? { coding: [{ system: PHYSICAL_TYPE_SYSTEM, code: f.physicalType, display: ptDisplay }] }
    : undefined;

  const alias = f.alias
    ? f.alias.split(",").map((s) => s.trim()).filter(Boolean)
    : undefined;

  return {
    status: f.status || "active",
    name: f.name?.trim(),
    mode: "instance",
    ...(alias && alias.length ? { alias } : {}),
    ...(f.description?.trim() ? { description: f.description.trim() } : {}),
    ...(type ? { type } : {}),
    ...(telecom.length ? { telecom } : {}),
    ...(address ? { address } : {}),
    ...(physicalType ? { physicalType } : {}),
    managingOrganization: {
      reference: `Organization/${f.managingOrgId}`,
      display: org?.name || undefined,
    },
  };
}
